module.exports = __webpack_public_path__ + "static/media/rgtu-logo.6162a491.jpeg";